import { render, staticRenderFns } from "./RoltekBanner.vue?vue&type=template&id=65347aa8&scoped=true"
import script from "./RoltekBanner.vue?vue&type=script&lang=js"
export * from "./RoltekBanner.vue?vue&type=script&lang=js"
import style0 from "./RoltekBanner.vue?vue&type=style&index=0&id=65347aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65347aa8",
  null
  
)

export default component.exports